import {
  GetAllstageswithstsatus,
  GetcmsContent,
  MarkDocumentRead,
  PPM,
  RequestNextStage,
} from "../../utils/Api/api";
import "./factSheet.scss";
import { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import useGeoLocation from "../../components/geoLocation/GeoLoaction";
import { Context } from "../../contextApi/contextProvider";
import parser from "html-react-parser";
import { ShimmerLoaderwhite } from "../../utils/loader/ShimmerLoader";
import { Stage } from "../../components/Question/Question";
import { getPostStatus } from "../../utils/isPostIdPresent";
import { AccessDOCOBJ } from "../../components/Navbar/Navbar";
import PpmPop from "../../utils/popMenu/PpmPop";
import { getDocumentSection } from "../../pages/PPMContent/Intro";
import { PageRoutes } from "../../utils/pageRoutes";
import { ArrowLeft, ArrowRight, Loader2 } from "lucide-react";
const FactSheet = () => {
  const loaction = useGeoLocation();
  const [ppmPop, setppmPop] = useState(false);
  const navigator = useNavigate();
  const [btnLoading, setBtnLoading] = useState(false);
  const { userLoginData, accessDoc, setAccessDoc } = useContext(Context);
  const [htmlString, setHtmlStr] = useState("");
  const [currentStatus, setCurrentStatus] = useState({
    name: "",
    status: "",
    uid: "",
  });
  const token = JSON.parse(localStorage.getItem("access_token") as string);
  const fetchData = async (data: PPM) => {
    if (!token) return;
    try {
      const response1 = await GetcmsContent(data);

      setHtmlStr(response1.data?.content);
    } catch (error) {
      console.error("Error fetching data from endpoint1:", error);
    }
  };

  const readDoc = async () => {
    if (!token) return;
    try {
      const { data } = await MarkDocumentRead({
        ip_address: await userLoginData.ip,
        latitude: loaction.coordinates?.lat ?? "0.0",
        longitude: loaction.coordinates?.lng ?? "0.0",
        post_id: "10509",
      });
    } catch (error) {}
  };
  const getDocumentStatusByPostId = (
    stages: Stage[],
    stage_name: string,
  ): string | undefined => {
    return stages
      .find((stage) => stage.stage_name.trim() === stage_name)
      ?.stage_status.trim();
  };
  useEffect(() => {
    if (userLoginData.status == 200) {
      readDoc();
      if (accessDoc?.all_stage_info) {
        const financialProjectionStage = getDocumentStatusByPostId(
          accessDoc?.all_stage_info,
          "Stage 1 - Business Insight",
        );
        if (financialProjectionStage) {
          setCurrentStatus({
            name: "",
            uid: "",
            status: financialProjectionStage || "",
          });
          fetchData({
            post_id: "10509",
            ip_address: userLoginData.ip,
            form_lat: loaction.coordinates.lat,
            form_lon: loaction.coordinates.lng,
          });
        } else {
          setCurrentStatus({
            name: "",

            uid: "",
            status: financialProjectionStage || "",
          });
          fetchData({
            post_id: "10509",
            ip_address: userLoginData.ip,
            form_lat: loaction.coordinates.lat,
            form_lon: loaction.coordinates.lng,
          });
        }
      }
    }

    if (token === "" || token === null || token === undefined) {
      navigator(PageRoutes.home);
    }
    if (userLoginData.status == 404) {
      navigator(PageRoutes.home);
    }
    window.scrollTo(0, 0);

    document.title = "TICCA | Fact Sheet";
  }, [userLoginData.status, accessDoc]);
  const getTalk = async () => {
    try {
      const response = await GetAllstageswithstsatus({
        ip_address: await userLoginData.ip,
        latitude: await loaction.coordinates.lat,
        longitude: await loaction.coordinates.lng,
      });

      if (response?.data) {
        const financialProjectionStage = await getDocumentStatusByPostId(
          response?.data?.all_stage_info,
          "Stage 1 - Business Insight",
        );

        setAccessDoc(response?.data);
        const updatedAccessDOCOBJ: AccessDOCOBJ = { ...accessDoc };
        Object.keys(updatedAccessDOCOBJ).forEach((key) => {
          const status = getPostStatus(key, response?.data?.all_stage_info);
          updatedAccessDOCOBJ[key] = status;
        });
        setAccessDoc({
          ...updatedAccessDOCOBJ,
          all_stage_info: response?.data?.all_stage_info,
        });

        if (financialProjectionStage) {
          setCurrentStatus({
            name: "",

            uid: "",
            status: financialProjectionStage || "",
          });
        } else {
          setCurrentStatus({
            name: "",

            uid: "",
            status: financialProjectionStage || "",
          });
        }
      }
    } catch (error) {}
  };
  const nextStage = async () => {
    setCurrentStatus({
      name: "",
      status: "",
      uid: "",
    });
    try {
      const { data } = await RequestNextStage({
        ip_address: await userLoginData.ip,
        latitude: await loaction.coordinates.lat,
        longitude: await loaction.coordinates.lng,
        section_id: await getDocumentSection(
          accessDoc?.all_stage_info,
          "Stage 1 - Business Insight",
        ),
      });

      if (data.status == 200) {
        getTalk();
        setppmPop(true);
        setCurrentStatus(data);
      }
      setBtnLoading(false);
    } catch (error) {}
  };
  const handleSubmit = async () => {
    if (btnLoading) return;
    if (currentStatus.status === "ALLOWED") {
      navigator(PageRoutes.ExecutiveSummary);
    }
    if (currentStatus.status === "") {
      setBtnLoading(true);
      nextStage();
    }
  };

  return (
    <>
      {ppmPop && <PpmPop setppmPop={setppmPop} />}
          <div className="responsive-table-container">
            {htmlString ? (
              <>
                {" "}
                <div className=""></div> {parser(htmlString)}
                <div className="w-full flex justify-center py-10">
                  <div className="flex flex-col sm:flex-row items-center gap-8">
                    {/* Back Button */}
                    <div className="relative group">
                      <button
                        disabled={btnLoading}
                        onClick={() => {
                          navigator(PageRoutes.InvestorCenter);
                        }}
                        className="
              flex items-center gap-2 px-8 py-3 rounded-2xl
              bg-white text-gray-700 font-semibold shadow-md
              border border-gray-200
              hover:shadow-lg hover:bg-gray-50
              disabled:opacity-60 disabled:cursor-not-allowed
              transition-all duration-300
            "
                      >
                        {btnLoading ? (
                          <Loader2 className="animate-spin w-5 h-5" />
                        ) : (
                          <>
                            <ArrowLeft size={18} />
                            Back
                          </>
                        )}
                      </button>

                      {/* Tooltip */}
                      {!btnLoading && (
                        <div
                          className="
              absolute left-1/2 -translate-x-1/2 bottom-full mb-[-5px] z-50 pointer-events-none
              bg-slate-800 text-white text-xs px-3 py-1 rounded-md
              opacity-0 group-hover:opacity-100
              transition-all duration-300
              shadow-md whitespace-nowrap
            "
                        >
                          Investor landing
                        </div>
                      )}
                    </div>

                    {/* Next Button */}
                    <div className="relative group">
                      <button
                        disabled={btnLoading}
                        onClick={() => {
                          handleSubmit();
                        }}
                        className="
              flex items-center gap-2 px-10 py-3 rounded-2xl
              bg-gradient-to-r from-blue-600 to-cyan-400
              text-white font-semibold shadow-md
              hover:shadow-xl hover:scale-[1.02]
              disabled:opacity-60 disabled:cursor-not-allowed
              transition-all duration-300
            "
                      >
                        {btnLoading ? (
                          <Loader2 className="animate-spin w-5 h-5" />
                        ) : (
                          <>
                            {accessDoc["13678"] === "PENDING"
                              ? "Your request is pending"
                              : accessDoc["13678"] === "DENIED"
                                ? "Your request is denied"
                                : accessDoc["13678"] === "ALLOWED"
                                  ? "Bussiness Summary"
                                  : "Learn More About TICCA"}
                            <ArrowRight size={18} />
                          </>
                        )}
                      </button>

                      {/* Tooltip */}
                      {!btnLoading && (
                        <div
                          className="
              absolute left-1/2 -translate-x-1/2 bottom-full mb-[-5px] z-50 pointer-events-none
              bg-slate-800 text-white text-xs px-3 py-1 rounded-md
              opacity-0 group-hover:opacity-100
              transition-all duration-300
              shadow-md whitespace-nowrap
            "
                        >
                          Bussiness Summary
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </>
            ) : (
              <>
                {" "}
                <ShimmerLoaderwhite maxWidth="40vw" />
              </>
            )}{" "}
          </div>
    </>
  );
};

export default FactSheet;
